module.exports = __webpack_public_path__ + "media/webfonts/fa-regular-400-b0e2db3b.eot";